module.exports = __webpack_public_path__ + "static/media/input_data_template_pick_ticket.9376d222.csv";